import { ErrorMessage, Form, Formik } from "formik";
import React, { useEffect, useState, useCallback } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  Input,
  SelectInput,
} from "../../../../../_metronic/_partials/controls";
import API from "../../../../helpers/devApi";
import * as Yup from "yup";
import * as Action from "../../_redux/applicantActions";
import Editor from "../../../../../_metronic/_partials/controls/Editor";
import moment from "moment";
import { swalConfirm, swalError, swalSuccess } from "../../../../helpers/swal";
import { Tag, Checkbox } from "antd";

const options = [
  {
    value: "contractual",
    label: "Contractual",
  },
  {
    value: "full_time",
    label: "Full Time",
  },
  {
    value: "part_time",
    label: "Part Time",
  },
  {
    value: "regular",
    label: "Regular",
  },
];

const _init = {
  certification_id: "",
  start_date: "",
  organisation_name: "",
  location: "",
  job_type: "",
  status: "",
  end_date: "",
  valid_till: "",
  area_of_expertise: [],
  department: "",
  industry_type_id: "",
  is_currently_working: false,
  achievement: "",
  supervisor_name: "",
  supervisor_email: "",
  supervisor_phone: "",
};

const ProfessionalExperience = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [experienceData, setExperienceData] = useState();
  const { id } = useParams();
  const { experienceList, personalInfo, industryType } = useSelector(
    ({ applicant }) => ({
      experienceList: applicant.experienceList,
      personalInfo: applicant.personal_info,
      industryType: applicant.industryType,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(Action.getAllIndustryType());
    if (id) {
      dispatch(Action.getAllExperiencedForApplicants(id));
      dispatch(Action.getApplicantPersonalInfo(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (experienceList && experienceList.length > 0) {
      const data = experienceList?.map((item) => {
        return {
          id: item?.hrms_experience__id,
          designation: item?.hrms_experience__designation,
          organisation_name: item?.hrms_experience__organisation_name,
          location: item?.hrms_experience__location,
          job_type: item?.hrms_experience__job_type,
          start_date: moment(item.hrms_experience__start_date).format(
            "YYYY-MM-DD"
          ),
          end_date: item.hrms_experience__end_date
            ? moment(item.hrms_experience__end_date).format("YYYY-MM-DD")
            : "",
          // area_of_expertise: item?.hrms_experience__area_of_expertise
          //   ? JSON.parse(item?.hrms_experience__area_of_expertise)
          //   : [],
          responsibilities: item.hrms_experience__responsibilities,
          department: item.hrms_experience__department,
          industry_type_id: item.hrms_experience__industry_type_id ?? "",
          achievement: item.hrms_experience__achievement,
          supervisor_name: item.hrms_experience__supervisor_name,
          supervisor_email: item.hrms_experience__supervisor_email,
          supervisor_phone: item.hrms_experience__supervisor_phone,
          is_currently_working:
            item.hrms_experience__is_currently_working == 1 ? true : false,
        };
      });
      setExperienceData({ list: data });
    } else {
      // setExperienceData({ list: [_init] });
      setExperienceData({ list: [] });
    }
  }, [experienceList]);

  const validationSchema = Yup.object().shape({
    list: Yup.array().of(
      Yup.object().shape({
        designation: Yup.string().required("designation is required"),
        department: Yup.string().required("department is required"),
        responsibilities: Yup.string().required("Responsibilities is required"),
        location: Yup.string().required("Location is required"),
        start_date: Yup.string().required("From date is required"),
        area_of_expertise: Yup.array()
          .min(1, "area of expertise is required")
          .required("area of expertise is required"),
        // end_date: Yup.string().required("To date is required"),
        end_date: Yup.string().when("is_currently_working", {
          is: (val) => val == false,
          then: Yup.string().required("end date is required"),
          otherwise: Yup.string(),
        }),
        industry_type_id: Yup.string().required("industry Type is required"),
        organisation_name: Yup.string().required(
          "Organisation_name is required"
        ),
      })
    ),
  });

  const handleSaveProfile = async (values) => {
    const formData = values?.list?.map((item) => {
      return {
        designation: item?.designation,
        organisation_name: item?.organisation_name,
        location: item?.location,
        start_date: item?.start_date,
        end_date: item?.end_date ? item?.end_date : null,
        is_currently_working: item?.is_currently_working ? 1 : 0,
        job_type: item?.job_type,
        responsibilities: item?.responsibilities,
        department: item?.department,
        industry_type_id: item?.industry_type_id,
        achievement: item?.achievement,
        supervisor_name: item?.supervisor_name,
        supervisor_email: item?.supervisor_email,
        supervisor_phone: item?.supervisor_phone,
        area_of_expertise: JSON.stringify(item?.area_of_expertise) || [],
        applicant_id: id,
      };
    });

    if (id && formData) {
      // const apiUrl = "http://localhost:6003/api/v1/hrms_experience/store";
      const apiUrl = "/hrms_experience/store";
      await API.post(apiUrl, { applicant_id: id, experiences: formData })
        .then(async (res) => {
          if (res.data.success) {
            await dispatch(Action.getAllExperiencedForApplicants(id));
            if (values?.list?.length) {
              dispatch(
                Action.createProfileScore(
                  {
                    name: ["Experience"],
                    applicant_id: id,
                  },
                  () => {
                    dispatch(Action.getApplicantPersonalInfo(id));
                  }
                )
              );
            } else {
              dispatch(
                Action.updateProfileScore(
                  {
                    name: ["Experience"],
                    applicant_id: id,
                  },
                  () => {
                    dispatch(Action.getApplicantPersonalInfo(id));
                  }
                )
              );
            }
            swalSuccess("Experience Information Updated Successfully!!");
            setLoading(false);
          } else {
            swalError("something went wrong");
          }
        })
        .catch((error) => {
          console.error(error);
        });
      setLoading(false);
    }
  };

  const handleOnChangeIsFresher = async (is_fresher) => {
    await API.patch(`/hrms_applicant/${id}`, { is_fresher })
      .then((res) => {
        if (res.data.success) {
          swalSuccess("Data updated successfully");
          if (is_fresher) {
            dispatch(
              Action.createProfileScore(
                {
                  name: ["Experience"],
                  applicant_id: id,
                },
                async () => {
                  dispatch(Action.getApplicantPersonalInfo(id));
                }
              )
            );
          } else {
            dispatch(
              Action.updateProfileScore(
                {
                  name: ["Experience"],
                  applicant_id: id,
                },
                async () => {
                  dispatch(Action.getApplicantPersonalInfo(id));
                }
              )
            );
          }
        } else {
          if (res.data.message) {
            swalError(res.data.message);
          } else {
            swalError("something went wrong");
          }
        }
      })
      .catch((error) => {
        console.log(error);
        swalError("something went wrong");
      });
  };

  const handleDelete = async (itemId, index) => {
    swalConfirm().then(async (res) => {
      if (res.isConfirmed) {
        // if(itemId) {
        //     API.delete(`/hrms_experience/${itemId}`).then((response) => {
        //         if (response.data.success) {
        //             dispatch(Action.getAllExperiencedForApplicants(id));
        //             swalSuccess("Experience Information deleted Successfully!!");
        //         } else {
        //             swalError("something went wrong");
        //         }
        //     })
        //     .catch((error) => {
        //         console.error(error);
        //     });
        // } else {
        const list = experienceData?.list;
        list.splice(index, 1);
        setExperienceData({ list: list });
        // }
      }
    });
  };
  const handleAdd = async (values) => {
    // const list = experienceData?.list;
    // let data = [...list, _init];
    const newArray = [...values.list];
    let data = [...newArray, _init];
    setExperienceData({ list: data });
  };

  const [areaExpertiseValues, setAreaExpertiseValues] = useState({});

  const handleInputChange = useCallback((value, index) => {
    setAreaExpertiseValues((prev) => ({
      ...prev,
      [index]: value,
    }));
  }, []);

  const handleKeyPress = useCallback(
    (e, index, setFieldValue, values) => {
      if (e.key === "Enter") {
        e.preventDefault();

        const expertise = areaExpertiseValues[index]?.trim();
        if (expertise) {
          const currentExpertise = values.list[index].area_of_expertise || [];

          if (!currentExpertise.includes(expertise)) {
            const updatedExpertise = [...currentExpertise, expertise];
            setFieldValue(`list[${index}].area_of_expertise`, updatedExpertise);
          }

          setAreaExpertiseValues((prev) => ({
            ...prev,
            [index]: "",
          }));
        }
      }
    },
    [areaExpertiseValues]
  );

  const handleSkillRemove = (skill, index, setFieldValue, values) => {
    const currentExpertise = values.list[index].area_of_expertise || [];
    const updatedExpertise = currentExpertise.filter((item) => item !== skill);
    setFieldValue(`list[${index}].area_of_expertise`, updatedExpertise);
  };

  return (
    <div className="card card_body_box mb-5">
      <Formik
        initialValues={experienceData}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={(values, { resetForm }) => {
          handleSaveProfile(values, resetForm);
        }}
      >
        {({ setFieldValue, values, errors, touched }) => (
          <Form>
            <div className="row">
              <div className="col-md-12">
                <div className="card_header_with_edit_btn">
                  <div className="title">
                    <h2>Experience </h2>
                  </div>
                </div>

                <hr />
              </div>
            </div>
            {values?.list?.map((item, i, row) => (
              <div className="row" key={i}>
                <div className="col-md-12 mb-4">
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <Input
                            name={`list[${i}].designation`}
                            label={"Designation"}
                            isRequired
                            value={item.designation}
                            onChange={(e) => {
                              setFieldValue(
                                `list[${i}].designation`,
                                e.target.value
                              );
                            }}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].designation`} />
                          </div>
                        </div>
                        <div className="col-md-6 mb-3">
                          <Input
                            name={`list[${i}].organisation_name`}
                            label={"Organization"}
                            isRequired
                            value={item.organisation_name}
                            onChange={(e) => {
                              setFieldValue(
                                `list[${i}].organisation_name`,
                                e.target.value
                              );
                            }}
                          />
                          <div className="text-danger">
                            <ErrorMessage
                              name={`list[${i}].organisation_name`}
                            />
                          </div>
                        </div>
                        <div className="col-md-6 mb-3">
                          <Input
                            name={`list[${i}].department`}
                            label={"Department"}
                            isRequired
                            value={item.department}
                            onChange={(e) => {
                              setFieldValue(
                                `list[${i}].department`,
                                e.target.value
                              );
                            }}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].department`} />
                          </div>
                        </div>
                        <div className="col-md-6 mb-3">
                          <Input
                            name={`list[${i}].location`}
                            label={"Location"}
                            isRequired
                            value={item.location}
                            onChange={(e) => {
                              setFieldValue(
                                `list[${i}].location`,
                                e.target.value
                              );
                            }}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].location`} />
                          </div>
                        </div>
                        <div className="col-md-6 mb-3">
                          <SelectInput
                            name={`list[${i}].industry_type_id`}
                            label={"Industry Type"}
                            options={industryType}
                            isRequired
                            onChange={(value) => {
                              setFieldValue(
                                `list[${i}].industry_type_id`,
                                value
                              );
                            }}
                            value={item.industry_type_id}
                          />
                          <div className="text-danger">
                            <ErrorMessage
                              name={`list[${i}].industry_type_id`}
                            />
                          </div>
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="required">Start Date</label>
                          <input
                            name={`list[${i}].start_date`}
                            type="date"
                            className="form-control"
                            value={item.start_date}
                            onChange={(e) => {
                              setFieldValue(
                                `list[${i}].start_date`,
                                e.target.value
                              );
                              setFieldValue(`list[${i}].end_date`, "");
                            }}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].start_date`} />
                          </div>
                        </div>

                        <div className="col-md-6 mb-3">
                          <label
                            className={
                              item?.is_currently_working ? "" : "required"
                            }
                          >
                            End Date
                          </label>
                          <input
                            name={`list[${i}].end_date`}
                            type="date"
                            disabled={item.is_currently_working}
                            className="form-control"
                            value={item.end_date}
                            onChange={(e) => {
                              setFieldValue(
                                `list[${i}].end_date`,
                                e.target.value
                              );
                            }}
                            min={item.start_date}
                          />
                          <Checkbox
                            checked={item?.is_currently_working}
                            onChange={(e) => {
                              setFieldValue(
                                `list[${i}].is_currently_working`,
                                e.target.checked
                              );
                            }}
                          >
                            I am currently working in this role
                          </Checkbox>
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].end_date`} />
                          </div>
                        </div>

                        <div className="col-md-6 mb-3">
                          <Input
                            name={`list[${i}].area_of_expertise`}
                            isRequired
                            label={"Area Of Expertise"}
                            value={areaExpertiseValues[i] || ""}
                            onChange={(e) =>
                              handleInputChange(e.target.value, i)
                            }
                            onKeyPress={(e) =>
                              handleKeyPress(e, i, setFieldValue, values)
                            }
                            placeholder="Type an area of expertise and press Enter"
                          />
                          <div style={{ marginTop: 10 }}>
                            {item?.area_of_expertise &&
                              item?.area_of_expertise.map((skill) => (
                                <Tag
                                  key={skill}
                                  closable
                                  onClose={() =>
                                    handleSkillRemove(
                                      skill,
                                      i,
                                      setFieldValue,
                                      values
                                    )
                                  }
                                >
                                  {skill}
                                </Tag>
                              ))}
                            <div className="text-danger">
                              <ErrorMessage
                                name={`list[${i}].area_of_expertise`}
                              />
                            </div>
                            {/* {item?.area_of_expertise} */}
                          </div>
                        </div>

                        <div className="col-md-6 mb-3">
                          <Input
                            name={`list[${i}].supervisor_name`}
                            label={"Supervisor's Name"}
                            value={item.supervisor_name}
                            onChange={(e) => {
                              setFieldValue(
                                `list[${i}].supervisor_name`,
                                e.target.value
                              );
                            }}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].supervisor_name`} />
                          </div>
                        </div>

                        <div className="col-md-6 mb-3">
                          <Input
                            name={`list[${i}].supervisor_email`}
                            label={"Supervisor's Email"}
                            value={item.supervisor_email}
                            onChange={(e) => {
                              setFieldValue(
                                `list[${i}].supervisor_email`,
                                e.target.value
                              );
                            }}
                          />
                          <div className="text-danger">
                            <ErrorMessage
                              name={`list[${i}].supervisor_email`}
                            />
                          </div>
                        </div>

                        <div className="col-md-6 mb-3">
                          <Input
                            name={`list[${i}].supervisor_phone`}
                            label={"Supervisor's Phone"}
                            value={item.supervisor_phone}
                            onChange={(e) => {
                              setFieldValue(
                                `list[${i}].supervisor_phone`,
                                e.target.value
                              );
                            }}
                          />
                          <div className="text-danger">
                            <ErrorMessage
                              name={`list[${i}].supervisor_phone`}
                            />
                          </div>
                        </div>

                        <div className="col-md-6 mb-3">
                          <Input
                            name={`list[${i}].achievement`}
                            label={"Achievement"}
                            value={item.achievement}
                            onChange={(e) => {
                              setFieldValue(
                                `list[${i}].achievement`,
                                e.target.value
                              );
                            }}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].achievement`} />
                          </div>
                        </div>

                        <div className="col-md-12 mb-3">
                          <label className="required">Responsibilities</label>
                          <Editor
                            editorHtml={item.responsibilities ?? ""}
                            onChange={(val) => {
                              setFieldValue(`list[${i}].responsibilities`, val);
                            }}
                          />

                          <div className="text-danger">
                            <ErrorMessage
                              name={`list[${i}].responsibilities`}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 mb-3 d-flex">
                          {i === values?.list?.length - 1 && (
                            <button
                              className="btn  add-button btn-sm text-white mr-5 text-nowrap"
                              onClick={() => {
                                handleAdd(values);
                              }}
                              type="button"
                            >
                              <i
                                className="fa fa-plus text-white"
                                aria-hidden="true"
                              ></i>
                              Add Experience
                            </button>
                          )}
                          {
                            <button
                              type="button"
                              className="btn btn-danger btn-sm  text-nowrap"
                              onClick={() => {
                                handleDelete(item.id, i);
                              }}
                            >
                              <i
                                className="fa fa-minus  text-white"
                                aria-hidden="true"
                              ></i>
                              Remove Experience
                            </button>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {!values?.list?.length && (
              <div className="row">
                <div
                  className="col-md-12"
                  style={{ display: "flex", gap: "2" }}
                >
                  {!personalInfo?.is_fresher ? (
                    <button
                      className="btn  add-button btn-sm text-white mr-5 text-nowrap"
                      onClick={() => {
                        handleAdd(values);
                      }}
                      type="button"
                    >
                      <i
                        className="fa fa-plus text-white"
                        aria-hidden="true"
                      ></i>
                      Add Experience
                    </button>
                  ) : (
                    <></>
                  )}
                  <div className="align-content-center">
                    <Checkbox
                      type="checkbox"
                      checked={personalInfo?.is_fresher}
                      id="is_fresher"
                      onChange={(e) => {
                        handleOnChangeIsFresher(e.target.checked ? 1 : 0);
                      }}
                    />
                    <label
                      className="form-check-label ml-2"
                      htmlFor="is_fresher"
                    >
                      <b>Are You Fresher?</b>
                    </label>
                  </div>
                </div>
              </div>
            )}

            <div className="edit_btn_group d-flex modal-footer m-0 p-0">
              {/* <button className='btn btn-default mr-4' >Cancel</button> */}
              {!personalInfo?.is_fresher ? (
                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={handleSaveProfile}
                  disabled={loading}
                >
                  Save
                </button>
              ) : (
                <></>
              )}
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default ProfessionalExperience;
